import React, { Component } from "react";
import PropTypes from "prop-types";
import LoadingWrapper from "../../common/loading-wrapper";
import { StackedBarChart, DiscreteColorLegend, makeWidthFlexible } from "@unifiedpatents/euclid-react";
import { colorScaleCategorical } from "@unifiedpatents/euclid-react/lib/helpers/colors";
import { removeOutlierByPercentile, nestedObjectsToGroupedSeries } from "@unifiedpatents/euclid-react/lib/helpers/preprocessors";
import { withChartConfig } from "../../common/chart-config-hoc";
const FlexibleStackedBarChart = withChartConfig(makeWidthFlexible(StackedBarChart));
import { countCasesByDate, countCasesByDateAndField } from "../../../services/api-reexam";

const colorScale = colorScaleCategorical();

class DateHistogram extends Component {
  static propTypes = {
    field: PropTypes.string.isRequired,
    field2: PropTypes.string,
    filter: PropTypes.object
  };

  static defaultProps = {
    filter: {}
  };

  state = {
    data: [],
    dataRaw: [], // for csv export
    loading: true
  };

  componentDidMount() {
    this._isMounted = true;
    this._getData(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this._getData(nextProps);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { loading } = this.state;
    const { field2 } = this.props;
    return (
      <LoadingWrapper loading={loading} spinSize="large" style={{ minHeight: 400, textAlign: "center" }}>
        {this._renderChart()}
        {field2 ? this._renderLegend() : null}
      </LoadingWrapper>
    );
  }

  _renderChart = () => {
    const { data } = this.state;
    return <FlexibleStackedBarChart data={data} height={500} tickLabelAngleX={-30} tickFormatX={v => v} />;
  };

  _renderLegend = () => {
    const field2Keys = this.state.data.map(d => d.k);
    return field2Keys.length > 0 && <DiscreteColorLegend orientation="horizontal" items={field2Keys} colors={[...field2Keys].map(colorScale)} />;
  };

  _getData = props => {
    if (this._isMounted) this.setState({ loading: true });
    const { field2, field, filter } = props;
    const apiCallPromise = field2 ? countCasesByDateAndField(filter, field, field2) : countCasesByDate(filter, field);
    apiCallPromise
      .then(res => {
        if (this._isMounted)
          this.setState({
            data: this._reformatData(res),
            dataRaw: res,
            loading: false
          });
      })
      .catch(() => {
        if (this._isMounted)
          this.setState({
            data: [],
            dataRaw: [],
            loading: false
          });
      });
  };

  _arrayToObj = (arr, key, v, keyConverter = undefined) => {
    let obj = {};
    arr.forEach(ele => {
      const objKey = keyConverter ? keyConverter(ele[key]) : ele[key];
      obj[objKey] = ele[v];
    });
    return obj;
  };

  // To keep stack in order
  _insertDummyValue = obj => {
    Object.keys(obj).forEach(key => {
      obj[key][""] = 0;
    });
  };

  _reformatData = data => {
    const { field2 } = this.props;
    const toLabel = ts => {
      const d = new Date(ts);
      return `${d.getUTCFullYear()}`;
    };
    if (field2) {
      let formatedData = this._arrayToObj(data, "key", "value", toLabel);
      Object.keys(formatedData).forEach(key => {
        formatedData[key] = this._arrayToObj(formatedData[key], "key", "doc_count");
      });
      this._insertDummyValue(formatedData);
      return removeOutlierByPercentile(nestedObjectsToGroupedSeries(formatedData), 99);
    } else {
      const formatedData = data.map(e => ({ k: toLabel(e.key), v: e.doc_count }));
      return [{ k: "Count", v: removeOutlierByPercentile(formatedData, 99) }];
    }
  };
}

export default DateHistogram;
